import React, { useEffect } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { Loading } from "../ui-components/Loading";
import Dashboard from "../pages/Dashboard/dashboard";
import TransactionListing from "../pages/Transaction/TransactionListing";
import TransactionSearchAndMapPage from "../pages/Transaction/TransactionSearchAndMapPage";
import TransactionAdd from "../pages/Transaction/TransactionAdd";

import Success from "../pages/Payment/Success";
import Pricing from "../pages/Payment/Pricing";
// import PricingTable from "../pages/Payment/PricingTable";
import CheckoutReturn from "../pages/Payment/CheckoutReturn";
// import EmbeddedCheckoutForm from "../pages/Payment/Checkout";
import { RootState } from "../store/reducers";

import { useDispatch, useSelector } from "react-redux";

import { useMsal } from "@azure/msal-react";
import Reports from "../pages/Reports";
import FinancialTrends from "../pages/FinancialTrends";
import BusinessPlanning from "../pages/BusinessPlanning";
import Settings from "../pages/Settings";
import ImportExport from "../pages/ImportExportPage";
import TransactionView from "../pages/Transaction/TransactionView";
import TransactionEdit from "../pages/Transaction/TransactionEdit";
import RepeatsAndReferrers from "../pages/RepeatsAndReferrers";
import BusinessZones from "../pages/BusinessZones";
import SignIn from "../pages/SignIn";
import LoggedOut from "../pages/LoggedOut";
import ChatVisibilityController from "../ui-components/ChatVisibilityController";
import EmailTemplates from "../pages/Settings/EmailTemplates";
import PropMixDashboard from "../pages/Admin/PropMixDashboard";
import { AdminPage } from "../pages/Admin/AdminPage";
import ImpersonationPage from "../pages/Admin/ImpersonationPage";
import AffiliatesAdminPage from "../pages/Admin/Affiliates/AffiliatesAdminPage";
import AffiliateDetailPage from "../pages/Admin/Affiliates/AffiliateDetailPage";
import { getUser } from "../store/modules/user/userActions";
import { AppDispatch } from "../store/store";

// const ProtectedTransactionListing= RequiresSubscription(TransactionListing);
function AuthenticatedRoutes() {
  const { instance } = useMsal();
  const account = instance.getActiveAccount();
  const dispatch = useDispatch<AppDispatch>();

  const {
    currentUser: user,
    loading: userLoading,
    error,
  } = useSelector((state: RootState) => state?.user);
  const [userLoadingRetried, setUserLoadingRetried] = React.useState(false);

  // If userLoading stuck, retry getUser once
  useEffect(() => {
    if (userLoading && !user && !userLoadingRetried) {
      const timer = setTimeout(() => {
        dispatch(getUser());
        setUserLoadingRetried(true);
      }, 5000);

      return () => clearTimeout(timer);
    }
  }, [userLoading, user, userLoadingRetried]);

  if (userLoading) {
    return <Loading />;
  }
  if (!account && !userLoading && (!user || error)) {
    return (
      <Routes>
        <Route path="/*" element={<LoggedOut />} />
      </Routes>
    );
    // return (
    //   <AuthErrorComponent
    //     message={error ?? "Something went wrong"}
    //     actionText="Sign In"
    //     actionLink="/signin"
    //   />
    // );
  }
  const isActive =
    user?.isAdmin ||
    user?.subscriptionStatus === "active" ||
    user?.subscriptionStatus === "trialing";
  return (
    <>
      <Routes>
        <Route path="/signin" element={<SignIn />} />
        {isActive && (
          <>
            <Route path="/dashboard" element={<Dashboard />} />
            <Route
              path="/transactions/:year"
              element={<TransactionListing />}
            />
            <Route path="/logged-out" element={<LoggedOut />} />
            <Route
              path="/transactions/:year/:yearId"
              element={<TransactionListing />}
            />
            {/* <Route
              path="/transactions/map/:year"
              element={<TransactionMapPage />}
            />
            <Route path="/transactions/map" element={<TransactionMapPage />} /> */}
            <Route
              path="/transactions/search-map/:year"
              element={<TransactionSearchAndMapPage />}
            />
            <Route
              path="/transactions/search-map"
              element={<TransactionSearchAndMapPage />}
            />

            <Route path="/business-zones" element={<BusinessZones />} />

            <Route
              path="/transactions/add/:year"
              element={
                <TransactionAdd />
              }
            />
            <Route
              path="/transactions/view/:transactionId"
              element={
                <TransactionView />
              }
            />
            <Route
              path="/transactions/edit/:transactionId"
              element={
                <TransactionEdit />
              }
            />
            <Route path="/analytics" element={<Reports />} />
            {(user.isPro === true || user.isAdmin === true) && (
              <Route path="/financial-trends" element={<FinancialTrends />} />
            )}

            <Route path="/business-planning" element={<BusinessPlanning />} />

            <Route path="/settings" element={<Settings />} />
            {user.isAdmin === true && (
              <>
                <Route
                  path="/settings/email-templates"
                  element={<AdminPage><EmailTemplates /></AdminPage>}
                />
                <Route path="/admin" element={<Navigate to="/admin/affiliates" replace />} />
                <Route path="/admin/propmix" element={<AdminPage><PropMixDashboard /></AdminPage>} />
                <Route path="/admin/impersonation" element={<AdminPage><ImpersonationPage /></AdminPage>} />
                <Route path="/admin/affiliates" element={<AdminPage><AffiliatesAdminPage /></AdminPage>} />
                <Route path="/admin/affiliates/:id" element={<AdminPage><AffiliateDetailPage /></AdminPage>} />
              </>
            )}
            <Route
              path="/repeats-and-referrers"
              element={<RepeatsAndReferrers />}
            />
            <Route path="/import" element={<ImportExport />} />
          </>
        )}
        {/* <Route
          path="/transactions/add/:yearId"
          element={<TransactionAdd isPro={user.isPro ?? false} />}
        /> */}

        <Route path="/pricing" element={<Pricing />} />
        <Route path="/pricing/confirmed" element={<Pricing />} />
        {/* <Route
          path="/payment/checkout/:priceId"
          element={<EmbeddedCheckoutForm />}
        /> */}
        <Route path="/payment/return" element={<CheckoutReturn />} />

        {/* <Route path="/subscribe" element={<PricingPlans />} /> */}
        <Route path="/payment/success" element={<Success />} />

        {/* {isAdmin && (
              <Route path="/admin/user-switch" element={<UserSwitchPage />} />
            )} */}
        {isActive && <Route path="*" element={<Dashboard />}></Route>}

        {!isActive && <Route path="*" element={<Pricing />}></Route>}
      </Routes>
      {/* Add the chat visibility controller to monitor routes */}
      <ChatVisibilityController />
    </>
  );
}

export default AuthenticatedRoutes;
